<template slot="acoes" slot-scope="data">
    <span
        class="text-primary">
        <i
            class="fa fa-info-circle fa-lg icon-button"
            title="Detalhar"
            @click.stop="detalharDespesa()"
        ></i>
    </span>
</template>

<script>

export default {
    props: {
        despesaId: {
            type: String
        },
    },

    methods: {
        detalharDespesa() {
            this.$router.push({
                name: `${this.$route.name}_Detalhar`,
                params: {
                    despesaId: this.despesaId
                }
            })
        }
    },
}

</script>